import React from 'react'

const ProgressBar = ({ percentage }) => {
    return (
        <div className="w-full bg-gray-200 dark:bg-gray-700">
            <div
                className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-1 leading-none rounded-md"
                style={{ width: `${percentage}%` }}
            >
                {percentage}%
            </div>
        </div>
    )
}

export default ProgressBar